import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './PageShell.css';
import './CreatePost.css';

const TEXT = {
  zh: {
    forum: '论坛',
    newPost: '发新帖',
    category: '选择板块 *',
    chooseCategory: '请选择板块',
    title: '帖子标题 *',
    titlePlaceholder: '请输入标题',
    content: '正文内容 *',
    contentPlaceholder: '写下你想说的...',
    required: '请填写标题、内容并选择板块',
    failed: '发布失败',
    submitting: '发布中...',
    submit: '发布帖子',
    cancel: '取消',
  },
  en: {
    forum: 'Forum',
    newPost: 'New post',
    category: 'Board *',
    chooseCategory: 'Choose a board',
    title: 'Post title *',
    titlePlaceholder: 'Enter a clear title',
    content: 'Content *',
    contentPlaceholder: 'Write your post...',
    required: 'Please add a title, content, and board.',
    failed: 'Failed to publish',
    submitting: 'Publishing...',
    submit: 'Publish post',
    cancel: 'Cancel',
  },
};

const CATEGORY_COPY = {
  en: {
    '经验分享': 'Experience sharing',
  },
};

export default function CreatePost() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const text = TEXT[language] || TEXT.en;
  const [searchParams] = useSearchParams();
  const defaultCat = searchParams.get('category') || '';
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ title: '', content: '', category_id: defaultCat });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/forum/categories').then(res => setCategories(res.data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.content || !form.category_id) {
      setError(text.required);
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/forum/posts', {
        title: form.title,
        content: form.content,
        category_id: Number(form.category_id),
      });
      navigate(`/forum/posts/${res.data.id}`);
    } catch (err) {
      setError(err.response?.data?.error || text.failed);
    } finally {
      setLoading(false);
    }
  };

  const localize = value => (language === 'en' ? CATEGORY_COPY.en[value] || value : value);

  return (
    <div className="page-shell-page create-post-page">
      <div className="container" style={{ maxWidth: 720, paddingTop: 40, paddingBottom: 48 }}>
      <div className="breadcrumb">
        <Link to="/forum">{text.forum}</Link>
        <span>/</span>
        <span>{text.newPost}</span>
      </div>
      <div className="page-header">
        <h1>{text.newPost}</h1>
      </div>
      <div className="card">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{text.category}</label>
            <select value={form.category_id} onChange={e => setForm(f => ({ ...f, category_id: e.target.value }))}>
              <option value="">{text.chooseCategory}</option>
              {categories.map(c => (
                <option key={c.id} value={c.id}>{c.icon} {localize(c.name)}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>{text.title}</label>
            <input
              value={form.title}
              onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
              placeholder={text.titlePlaceholder}
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label>{text.content}</label>
            <textarea
              value={form.content}
              onChange={e => setForm(f => ({ ...f, content: e.target.value }))}
              placeholder={text.contentPlaceholder}
              rows={10}
            />
          </div>
          {error && <p className="error-msg">{error}</p>}
          <div style={{ display: 'flex', gap: 12 }}>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? text.submitting : text.submit}
            </button>
            <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>{text.cancel}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  );
}
